/**
 * Reducers specify how the application's state changes in response to actions sent to the store.
 *
 * @see https://redux.js.org/basics/reducers
 */
import { createReducer } from 'reduxsauce';
import { InbOrd06Types } from './Actions';
import INITIAL_STATE from './InitialState';

export const inbOrd06ResetTimestamp = (state, { currentPage, sorts, filters, pageSize }) => ({
  ...state,
  currentPage: currentPage || state.currentPage,
  sorts: sorts || state.sorts,
  filters: filters || state.filters,
  pageSize: pageSize || state.pageSize,
  timestamp: Date.now()
});

export const inbOrd06FetchInbOrd06Loading = (state, { boolean }) => ({
  ...state,
  fetchIsLoading: boolean
});

export const inbOrd06FetchInbOrd06Success = (
  state,
  { documents, currentPage, lastPage, total, pageSize }
) => ({
  ...state,
  documents,
  currentPage,
  lastPage,
  total,
  pageSize
});

export const inbOrd06AddSelectedDocuments = (state, { selectedDocuments }) => {
  const selectIds = state.selectedDocuments.map(value => value.id);
  return {
    ...state,
    selectedDocuments: [
      ...state.selectedDocuments,
      ...selectedDocuments.filter(data => {
        return !selectIds.includes(data.id);
      })
    ]
  };
};

export const inbOrd06RemoveSelectedDocuments = (state, { selectedDocuments }) => {
  const selectIds = selectedDocuments.map(value => value.id);
  return {
    ...state,
    selectedDocuments: state.selectedDocuments.filter(data => {
      return !selectIds.includes(data.id);
    })
  };
};

export const inbOrd06SetWorkspaceVisible = (state, { boolean }) => ({
  ...state,
  workspaceIsVisible: boolean
});

export const inbOrd06CreateInbOrd06Loading = (state, { boolean }) => ({
  ...state,
  createIsLoading: boolean
});

export const inbOrd06CreateInbOrd06Success = (state, { newDocuments }) => ({
  ...state,
  timestamp: Date.now(),
  selectedDocuments: [],
  newDocuments
});

/**
 * @see https://github.com/infinitered/reduxsauce#createreducer
 */
export const reducer = createReducer(INITIAL_STATE, {
  [InbOrd06Types.INB_ORD06_RESET_TIMESTAMP]: inbOrd06ResetTimestamp,
  [InbOrd06Types.INB_ORD06_FETCH_INB_ORD06_LOADING]: inbOrd06FetchInbOrd06Loading,
  [InbOrd06Types.INB_ORD06_FETCH_INB_ORD06_SUCCESS]: inbOrd06FetchInbOrd06Success,
  [InbOrd06Types.INB_ORD06_ADD_SELECTED_DOCUMENTS]: inbOrd06AddSelectedDocuments,
  [InbOrd06Types.INB_ORD06_REMOVE_SELECTED_DOCUMENTS]: inbOrd06RemoveSelectedDocuments,
  [InbOrd06Types.INB_ORD06_SET_WORKSPACE_VISIBLE]: inbOrd06SetWorkspaceVisible,
  [InbOrd06Types.INB_ORD06_CREATE_INB_ORD06_LOADING]: inbOrd06CreateInbOrd06Loading,
  [InbOrd06Types.INB_ORD06_CREATE_INB_ORD06_SUCCESS]: inbOrd06CreateInbOrd06Success
});
